import { render, staticRenderFns } from "./JdsNavigatorBackLink.vue?vue&type=template&id=e62549f4&scoped=true&"
import script from "./JdsNavigatorBackLink.vue?vue&type=script&lang=ts&"
export * from "./JdsNavigatorBackLink.vue?vue&type=script&lang=ts&"
import style0 from "./JdsNavigatorBackLink.vue?vue&type=style&index=0&id=e62549f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62549f4",
  null
  
)

export default component.exports